import { format } from 'date-fns';
import { DATE_FORMAT, TIME_FORMAT } from '../constants/dateTime';
export function getDateTimestamp(date) {
  var timestamp = date.toISOString();
  return {
    date: format(date, DATE_FORMAT),
    time: format(date, TIME_FORMAT),
    timestamp: timestamp
  };
}